import Service from '../../Services/Service';

const ServiceMenuAPI = {
    getServiceMenuByBranch(branch_id,lang){
        return Service.get(`/site/service_menu_by_branch?branch_id=${branch_id}&lang=${lang}`);
    },
    getMembershipRateByBranch(branch_id,lang){
        return Service.get(`/site/membership_rate_by_branch?branch_id=${branch_id}&lang=${lang}`);
    },
    getAllOurService(){
        return Service.get(`/get-all-our-services`);
    },
    getOurServiceDetail(id){
        return Service.get(`/our-service/details/${id}`);
    },
}
export default ServiceMenuAPI
